import { render, staticRenderFns } from "./SpectMiocardicaView.vue?vue&type=template&id=12375270"
import script from "./SpectMiocardicaView.vue?vue&type=script&lang=js"
export * from "./SpectMiocardicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports